import createReducer from '../createReducer'
import {
  SIGN_IN,
  SIGN_IN_SUCCESSFUL,
  SIGN_IN_FAILURE,
  SIGN_UP,
  SIGN_UP_SUCCESSFUL,
  SIGN_UP_FAILURE,
  GET_MY_DATA,
  GET_MY_DATA_SUCCESSFUL,
  GET_MY_DATA_FAILURE,
  LOGOUT,
  SET_LANG,
  CLEAN_AUTH,
  SIGN_IN_TEMPORARY_SUCCESS
} from './constants'

const initialState = {
  user: {},
  recover: {
    isFetching: false,
    userPhrase: undefined
  },
  isLogged: false,
  isFetching: false,
  isError: false,
  isSuccess: false,
  isSubmitting: false,
  errorMessage: '',
  lang: 'pt-BR'
}

const auth = createReducer(initialState, {
  [SIGN_IN]: (state, action) => ({
    ...state,
    isFetching: true,
    isSubmitting: true,
    isLogged: false,
    isError: false,
    errorMessage: ''
  }),
  [SIGN_IN_SUCCESSFUL]: (state, action) => ({
    ...state,
    isFetching: false,
    isLogged: true,
    isSubmitting: false,
    isError: false,
    user: action.payload,
    errorMessage: ''
  }),
  [SIGN_IN_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    isSubmitting: false,
    isLogged: false,
    user: {},
    isError: true,
    errorMessage: action.payload
  }),
  [SIGN_IN_TEMPORARY_SUCCESS]: (state, action) => ({
    ...state,
    isFetching: false,
    isLogged: false,
    isSubmitting: false,
    isError: false,
    user: action.payload,
    errorMessage: ''
  }),
  [SIGN_UP]: (state, action) => ({
    ...state,
    isFetching: true
  }),
  [SIGN_UP_SUCCESSFUL]: (state, action) => ({
    ...state,
    isFetching: false,
    isSuccess: true
  }),
  [SIGN_UP_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    isSuccess: false
  }),
  [LOGOUT]: (state, action) => ({
    ...initialState
  }),
  [GET_MY_DATA]: (state, action) => ({
    ...state,
    isFetching: true,
    isSubmitting: false,
    isError: false,
    errorMessage: ''
  }),
  [GET_MY_DATA_SUCCESSFUL]: (state, action) => ({
    ...state,
    isFetching: false,
    isSubmitting: false,
    isLogged: true,
    isError: false,
    user: action.payload,
    errorMessage: ''
  }),
  [GET_MY_DATA_FAILURE]: (state, action) => ({
    ...state,
    isFetching: false,
    isLogged: false,
    isSubmitting: false,
    user: {},
    isError: true,
    errorMessage: action.payload
  }),
  [SET_LANG]: (state, action) => ({
    ...state,
    lang: action.payload.lang
  }),
  [CLEAN_AUTH]: (state, action) => ({
    ...initialState
  })
})

export default auth
